import React, { Fragment } from "react";
import Login from "../Pages/Authentication/Loginpage/login-page";
import Signup from "../Pages/Authentication/SignUp/Signup";
import AuthVerification from "../Pages/Authentication/AuthVerification/AuthVerification";
import ForgetPassword from "../Pages/Authentication/ForgetPassword/ForgetPassword";
import ProtectedRoutes from "../components/ProtectedRoute/ProtectedRoutes";
import PublicRoutes from "../components/PublicRoute/PublicRoutes";
import AllPostRelatedToTheScreen from "../Pages/Post/getAllPostRelatedToTheScreen/getAllPostRelatedToTheScreen";
import Dashboard from "../Pages/Dashboard/Dashboard";
import Media from "../Pages/Media/Media";
import AddNewScreen from "../Pages/Screen/AddNewScreen/AddNewScreen";
import AddNEWPOST from "../Pages/Post/AddNewPost/AddNewPost";
import AppLayout from "../components/AppLayout/AppLayout";
import LayoutPreview from "../Pages/Post/LayoutsPreview/LayoutPreview";
import PingHistory from "../Pages/Logs/LogHistory/LogHistory";
import EditPost from "../Pages/Post/EditPost/EditPost";
import UserInfo from "../Pages/Profile/UserInfo/UserInfo";
import PageNotFound from "../components/Lotties/RestrictedPage/404";
import PageLoading from "../components/Loaders/ProtectedPublicLoading/PageLoading";
import AddNewGroup from "../Pages/Group/AddNewGroup/AddNewGroup";
import {
  createRoutesFromElements,
  RouterProvider,
  Route,
  Navigate,
  createBrowserRouter,
} from "react-router-dom";
import Error from "../components/ErrorElement/Error";
import NewScreenMediaMapping from "../Pages/Post/getAllPostRelatedToTheScreen/NewScreenMediaMapping";
import ScreenMediaData from "../Pages/Post/getAllPostRelatedToTheScreen/ScreenMediaData";
import NewGroupMediaMapping from "../Pages/Post/getAllPostRelatedToTheGroup/AddNewGroupMediaMapping";
import LandingPage from '../Pages/LandingPage/LandingPage';
import Billing from '../Pages/Billing/Billing_new';
import TermsCondition from "../Pages/TermsCondition/TermsCondition";
import PrivacyPolicy from "../Pages/PrivacyPolicy/PrivacyPolicy";
// import Billing from "../Pages/Billing/Billing";

const MainRoutes = () => {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Fragment>
        <Route path="/landingpage" element={<LandingPage />} errorElement={<Error />}/>
        <Route
              path="/TermsCondition"
              element={<TermsCondition />}
              errorElement={<Error />}
            />
          <Route
              path="/PrivacyPolicy"
              element={<PrivacyPolicy />}
              errorElement={<Error />}
            />
        <Route path="/" element={<ProtectedRoutes />} errorElement={<Error />}>
          <Route path="/" element={<AppLayout />} errorElement={<Error />}>
            <Route
              path="/"
              element={<Navigate replace to="dashboard" />}
              errorElement={<Error />}
            />
            <Route
              path="/dashboard"
              element={<Dashboard />}
              errorElement={<Error />}
            />
            <Route path="/media" element={<Media />} errorElement={<Error />} />
            <Route
              path="/screens"
              element={<AddNewScreen />}
              errorElement={<Error />}
            />
            <Route
              path="/groups"
              element={<AddNewGroup />}
              errorElement={<Error />}
            />
            <Route
              path="/pinghistory"
              element={<PingHistory />}
              errorElement={<Error />}
            />
            <Route
              path="/posts"
              // element={<AllPostRelatedToTheScreen />}
              // element={<NewScreenMediaMapping />}
              element={<ScreenMediaData />}
              errorElement={<Error />}
            />
            <Route
              path="/groupposts"
              // element={<AllPostRelatedToTheScreen />}
              element={<NewGroupMediaMapping />}
              errorElement={<Error />}
            />
            <Route
              path="/addnewpost"
              element={<AddNEWPOST />}
              errorElement={<Error />}
            />
            <Route
              path="/editPost"
              element={<EditPost />}
              errorElement={<Error />}
            />
            <Route
              path="/layoutpreview"
              element={<LayoutPreview />}
              errorElement={<Error />}
            />
            <Route
              path="/userinfo"
              element={<UserInfo />}
              errorElement={<Error />}
            />
            <Route
            path="/billing"
            element={<Billing/>}
            errorElement={<Error />}
            />
          </Route>
         
        </Route>
        <Route path="/" element={<PublicRoutes />} errorElement={<Error />}>
          <Route path="login" element={<Login />} errorElement={<Error />} />
          <Route path="signup" element={<Signup />} errorElement={<Error />} />
          <Route
            path="authverification"
            element={<AuthVerification />}
            errorElement={<Error />}
          />
          <Route
            path="forgetpassword"
            element={<ForgetPassword />}
            errorElement={<Error />}
          />
          
        </Route>
        <Route path="*" element={<PageNotFound />} errorElement={<Error />} />
      </Fragment>
    ),
    {
      basename: "/cms"
      // basename: "/cms_grouping"
      // basename: "/cms_freemium"
    }
  );

  return <RouterProvider router={router} fallbackElement={<PageLoading />} />;
};

export default MainRoutes;